import axios from 'axios'

const endPoint = "slots"

export function getDropIn({ state, commit, rootState }) {
  return new Promise((resolve, reject) => {
      axios
          .post("coachingblock/drop-in", {company_check: false})
          .then(response => {
            let authUser = rootState.auth.authUser;
            commit('setDropIns', {data: response.data.data, authUser: authUser})
            commit('isDropInDataLoaded', response.data.data.length > 0 ? true : false)
            resolve(response.data.data)
          })
          .catch(err => {
            commit('isDropInDataLoaded', false)
            reject(err)
          })
  })
}
export function coachSlotRegister({ commit }, data) {

  let log = {
      app_id: 'customer_web_app',
      function: 'coachSlotRegister',
      endpoint: 'coachingblock/' + data.blockId + '/slots/registerunregister/' + data.slotId,
      method: 'post',
      request: { register_option: data.register_option },
      status: {}
  }

  return new Promise((resolve, reject) => {
      axios
          .post( 'coachingblock/' + data.blockId + '/slots/registerunregister/' + data.slotId, {
              register_option: data.register_option,
              track_id: data.trackId,
          })
          .then(response => {
              commit("setLastUpdated")
              log.status = response.status
              this.dispatch('miscellaneous/logEvent', log)
              resolve(response.data)
          })
          .catch(err => {
              log.status = err.response.status
              this.dispatch('miscellaneous/logEvent', log)
              reject(err)
          })
  })
}

export function checkSlotAvailability({ state }, data) {
    console.log("Data in checkSlotAvailability:", data);
    let endpoint = 'coachingblock/' + data.coaching_block_id + '/slots/checkAvailability/' + data.block_slot_id;
    let payload = {
      track_id: data.track_id,
    };

    return new Promise((resolve, reject) => {
        axios.post(endpoint, payload)
            .then(response => {
                console.log('Backend Response:', response.data);
                
                if (response.data.code === 200) {
                    resolve(response.data.data.available_capacity > 0);
                } else {
                    console.log('Backend Error:', response.data.message);
                    reject(new Error(response.data.message));
                }
            })
            .catch(err => {
                console.error("Error checking slot availability", err);
                reject(err);
            });
    });
}

export function getCoachingblock({ state, commit, rootState }) {
  return new Promise((resolve, reject) => {
      axios
          .post("coachingblock/coachingblock", {company_check: false})
          .then(response => {
              let authUser = rootState.auth.authUser;
              commit('setCoachingBlocks', {data: response.data.data, authUser: authUser})
              commit('isCTDataLoaded', response.data.data.length > 0 ? true : false)
              resolve(response.data.data)
          })
          .catch(err => {
              commit('isCTDataLoaded', false)
              reject(err)
          })
  })
}


export function getCoachingtracks({ state, commit, rootState }) {
    return new Promise((resolve, reject) => {
        axios
            .get(`${endPoint}/${rootState.auth.authUser._id}`)
            .then(response => {
                commit('setCoachingTracks', response.data.data)
                resolve(response.data.data)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export function addRegistrationCode({ state, commit }) {
    return new Promise((resolve, reject) => {
        axios
            .post(`coachingblock/add-registration-code`, { 'registration_code': state.registration_code })
            .then(response => {
                commit('clearRegistrationCode')
                resolve(response)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export function getCoachCoachingblock({ state, commit, rootState }) {
  return new Promise((resolve, reject) => {
      axios
          .get(`slots/${rootState.auth.authUser._id}/Pending`)
          .then(response => {
              commit('setCoachCoachingBlocks', response.data.data)
              commit('isCoachingBlocksDataLoaded', response.data.data.length > 0 ? true : false)
              resolve(response.data.data)
          })
          .catch(err => {
              commit('isCoachingBlocksDataLoaded', false)
              reject(err)
          })
  })
}

export function setSlotStatus({ commit }, data) {

  let log = {
      app_id: 'customer_web_app',
      function: 'setSlotStatus',
      endpoint: `events/slots/${data.slot_id}/coachAssignStatus`,
      method: 'put',
      request: { coach_assign_status: data.coach_assign_status },
      status: {}
  }

  return new Promise((resolve, reject) => {
      axios
          .put(`events/slots/${data.slot_id}/coachAssignStatus`, {
              coach_assign_status: data.coach_assign_status
          })
          .then(response => {
              // update last updated time, to fire subscribe event and sync the slots
              commit("setLastUpdated")
              log.status = response.status
              this.dispatch('miscellaneous/logEvent', log)
              resolve(response.data)
          })
          .catch(err => {
              log.status = err.response.status
              this.dispatch('miscellaneous/logEvent', log)
              reject(err)
          })
  })
}


export function resetStore({ commit, store }) {
    commit('resetStore')
}
